import 'css-chunk:src/app/components/InstallApplicationDrawer/InstallApplicationDrawer.scss';export default {
  "InstallApplicationDrawer": "_InstallApplicationDrawer_12fc3_1",
  "form": "_form_12fc3_1",
  "submitButton": "_submitButton_12fc3_1"
};